import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { UserStateService } from '../../features/user/services';

export const authGuard: CanActivateFn = () => {
  const userStateService = inject(UserStateService);
  const router = inject(Router);

  return toObservable(userStateService.authReady).pipe(
    filter((ready) => ready),
    take(1),
    map(() => {
      if (userStateService.isLoggedIn()) {
        return true;
      }
      return router.createUrlTree(['/landing']);
    }),
  );
};
